namespace TabAurous.ProductDevelopment {
    export interface PDInterfaceRow {
        TransId?: number;
        TransDate?: string;
        VoucherNo?: string;
        VoucherTypeId?: number;
        RefVoucherId?: number;
        PartyId?: number;
        POSCustomerId?: number;
        PosCustomerCode?: string;
        CustomerName?: string;
        TermsId?: number;
        CurrencyId?: number;
        ExchRate?: number;
        NetAmount?: number;
        CcNetAmount?: number;
        Roundoff?: number;
        TaxAmount?: number;
        ReceiptAmount?: number;
        Discount?: number;
        AdditionalCharges?: number;
        GrossAmount?: number;
        CcGrossAmount?: number;
        Pieces?: number;
        Weight?: number;
        NetWeight?: number;
        Remark?: string;
        CompanyId?: number;
        BillNo?: string;
        BillDate?: string;
        ChallanNo?: string;
        ChallanDate?: string;
        EmployeeId?: number;
        AddressId?: number;
        ShipmentId?: number;
        ShipAddressId?: number;
        ECommOrderId?: number;
        ECommOrderNo?: string;
        ReasonId?: number;
        FinancialYearId?: number;
        UserId?: number;
        OrderStatusId?: number;
        OrderStatusName?: string;
        CustomerRequirements?: CustomerRequirementItemsRow[];
        Designing?: CustomerRequirementItemsRow[];
        SpecSheets?: SpecSheetItemsRow[];
        Quotations?: PDQuotationItemsRow[];
    }

    export namespace PDInterfaceRow {
        export const idProperty = 'TransId';
        export const nameProperty = 'VoucherNo';
        export const localTextPrefix = 'ProductDevelopment.PDInterface';
        export const deletePermission = 'EComm:ECommOrder:Delete';
        export const insertPermission = 'EComm:ECommOrder:Add';
        export const readPermission = '*';
        export const updatePermission = 'EComm:ECommOrder:Edit';

        export declare const enum Fields {
            TransId = "TransId",
            TransDate = "TransDate",
            VoucherNo = "VoucherNo",
            VoucherTypeId = "VoucherTypeId",
            RefVoucherId = "RefVoucherId",
            PartyId = "PartyId",
            POSCustomerId = "POSCustomerId",
            PosCustomerCode = "PosCustomerCode",
            CustomerName = "CustomerName",
            TermsId = "TermsId",
            CurrencyId = "CurrencyId",
            ExchRate = "ExchRate",
            NetAmount = "NetAmount",
            CcNetAmount = "CcNetAmount",
            Roundoff = "Roundoff",
            TaxAmount = "TaxAmount",
            ReceiptAmount = "ReceiptAmount",
            Discount = "Discount",
            AdditionalCharges = "AdditionalCharges",
            GrossAmount = "GrossAmount",
            CcGrossAmount = "CcGrossAmount",
            Pieces = "Pieces",
            Weight = "Weight",
            NetWeight = "NetWeight",
            Remark = "Remark",
            CompanyId = "CompanyId",
            BillNo = "BillNo",
            BillDate = "BillDate",
            ChallanNo = "ChallanNo",
            ChallanDate = "ChallanDate",
            EmployeeId = "EmployeeId",
            AddressId = "AddressId",
            ShipmentId = "ShipmentId",
            ShipAddressId = "ShipAddressId",
            ECommOrderId = "ECommOrderId",
            ECommOrderNo = "ECommOrderNo",
            ReasonId = "ReasonId",
            FinancialYearId = "FinancialYearId",
            UserId = "UserId",
            OrderStatusId = "OrderStatusId",
            OrderStatusName = "OrderStatusName",
            CustomerRequirements = "CustomerRequirements",
            Designing = "Designing",
            SpecSheets = "SpecSheets",
            Quotations = "Quotations"
        }
    }
}
